import React from 'react';
import { Accordion, Menu } from 'semantic-ui-react';
// allows using `map` on a dictionary
import map from 'lodash.map';
import styles from './SidebarLowerMenu.styles';
import { SORTED_DIVISIONS } from '../../../../../store/actions/teams.types';
import { NavLink } from '../../../../../lib/components/link';
import { viewTeam } from '../../../../views/Team/module/team';

const SidebarTeamsMenu = (key, league) => (
  <Accordion.Content style={styles.accordianContent} key={`${key}_Content`}>
    <Menu vertical style={styles.menu}> {
     map(league, (conference, conferenceName) => (
        SORTED_DIVISIONS.map(divisionName => (
          <fØ>
            <div className="division" key={divisionName} style={styles.teamsDivisionName}>
              {conferenceName} {divisionName}
            </div> {
            conference[divisionName].map(team => {
              if (team.name != 'Agent')
              return (
              <NavLink
                action={viewTeam({ id: team.id, teamName: team.slug })}
                style={styles.link}
                className="sidebarMenuItem"
                activeClassName="activeNav"
                key={team.id}
                exact
              >
                {team.city} {team.name}
              </NavLink>
            )})}
          </fØ>
        ))
    ))}
    </Menu>
  </Accordion.Content>
);

export default SidebarTeamsMenu;



// WEBPACK FOOTER //
// ./src/app/components/Nav/MobileNav/Sidebar/SidebarTeamsMenu.js